import { ErrorResponse, fetchAPI } from '@quickbit/backoffice-core-frontend';
import { useMutation } from '@tanstack/react-query';

export interface ChainalysisCluster {
  name: string | null;
  categoryId: number | null;
}

export interface ChainalysisLookupResult {
  transactionId: string;
  transactionType: string | null;
  asset: string | null;
  rating: string | null;
  cluster: ChainalysisCluster | null;
  transferReference: string | null;
  notes: string | null;
}

export interface ChainalysisLookupResponse {
  results: ChainalysisLookupResult[];
}

export const useChainalysisLookup = () => {
  return useMutation<
    ChainalysisLookupResponse,
    ErrorResponse,
    { transactionIds: string[] }
  >({
    mutationFn: async ({ transactionIds }) => {
      return await fetchAPI<ChainalysisLookupResponse>(
        'v1/fcu/chainalysis-lookup',
        {
          method: 'POST',
          body: { transactionIds },
        }
      );
    },
  });
};

export interface ChainalysisAlertInfo {
  level: string;
  category: string | null;
  alertStatus: string;
  handledByUs: boolean;
  alertAmountUsd: string;
}

export interface ChainalysisTransferRow {
  direction: string;
  asset: string;
  amount: string;
  amountUsd: string;
  transferReference: string;
  cluster: ChainalysisCluster | null;
  alerts: ChainalysisAlertInfo[];
  qbTransactionId: string | null;
}

export interface ChainalysisUserLookupResult {
  userId: string;
  transfers: ChainalysisTransferRow[];
  notes: string | null;
}

export interface ChainalysisUserLookupResponse {
  results: ChainalysisUserLookupResult[];
}

export const useChainalysisUserLookup = () => {
  return useMutation<
    ChainalysisUserLookupResponse,
    ErrorResponse,
    { userIds: string[] }
  >({
    mutationFn: async ({ userIds }) => {
      return await fetchAPI<ChainalysisUserLookupResponse>(
        'v1/fcu/chainalysis-user-lookup',
        {
          method: 'POST',
          body: { userIds },
        }
      );
    },
  });
};
